/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Folder (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgFolder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M33 47V37a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H35a2 2 0 0 1-2-2"
    />
  </svg>
);
export default SvgFolder;
